<template>
    <div class="d-inline-block">
        <div v-for="(period, n) in periods" class="d-inline-block mr-2">
            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button" class="btn btn-secondary">
                    {{ period.open }} - {{ period.close }}
                </button>

                <period-modal :open="period.open"
                              :close="period.close"
                              @update="updatePeriod"/>

                <button type="button" class="btn btn-secondary" @click="deletePeriod(period.open)">
                    <i class="fas fa-trash p-0"/>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import PeriodModal from './PeriodModal'

export default {
    props: {
        periods: Array,
        day: Number,
    },

    components: {
        PeriodModal,
    },

    methods: {
        deletePeriod(open) {
            this.$emit('delete', this.day, open)
        },

        updatePeriod(open, close, newOpen, newClose) {
            this.$emit('update', this.day, open, close,
                newOpen, newClose)
        },
    },
}
</script>
